import { useCallback, useState } from "react";
import api from "../../../../utils/api";
import { EventosPg } from "../../../../types";
import { useQuery } from "@tanstack/react-query";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";
import useAuth from "../../../../hooks/useAuth";

export type ResponseMembrosCheckin = {
  list: EventosPg[] | []
  reset: VoidFunction,
  nextPagina: VoidFunction
  alterParams: (field: 'sede' | 'ministerio' | 'celula', value: string | undefined) => void
  refetch: VoidFunction
  pagina: number,
  params: { sede: string, ministerio: string, celula: string } | undefined
  isLoading: boolean,
  pesquisarPorNomeEmail: string,
  getSearchPerNameEmail: (event: any) => void
  handlePut: (element: {nome: string, telefone: string, email: string, id: string}|undefined) => void
}

const GetEvents = (): ResponseMembrosCheckin => {

  const [pagina, setPagina] = useState<number>(0);

  const { setMensagemError, setMensagemSuccess } = useErrorSuccess();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const {
    idUsuario
  } = useAuth()


  const [params, setParams] = useState<{ sede: string, ministerio: string, celula: string }>({ sede: '0', ministerio: '0', celula: '0' });


  const [pesquisarPorNomeEmail, setPesquisaPorMinisterio] = useState('');


  const alterParams = (field: 'sede' | 'ministerio' | 'celula', value: string | undefined) => setParams((valor) => ({...valor, [field]: value}))


  const getSearchPerNameEmail = (event: any) => setPesquisaPorMinisterio(event?.target?.value);

  const getWithParams = async () => {
    try {
      const getPar = params ? Object.values(params) : undefined;
      const req = await api.get<EventosPg[]>(`view/registropg/${idUsuario}/${getPar ? getPar?.toString()?.replaceAll(',', '/'): ''}`);
      const res = req?.data;
      setPagina(1);
      return res;
    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data) || 'Erro ao tentar trazer a lista de Membors')
      return []
    }
  }

  const { data: listCheckinMembros = [], refetch } = useQuery({
    queryFn: getWithParams
  })

  const handlePut = async (usuario: {nome: string, telefone: string, email: string, id: string}|undefined) => {
    setIsLoading(true);
    try {
      const req = await api.put('usuario/'+usuario?.id, usuario);
      const res = req.data;

      setMensagemSuccess('Alterado!');

      await refetch();

    } catch(error) {

      setMensagemError(JSON.stringify(error?.response?.data) || 'Erro de Requisição')

    } finally {
      setIsLoading(false);
    }
  }

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const reset = async () => {
    try {
      setParams(undefined);
    } finally {
      await refetch();
    }
  }



  return {
    list: listCheckinMembros,
    reset,
    nextPagina,
    pesquisarPorNomeEmail,
    getSearchPerNameEmail,
    pagina,
    alterParams,
    refetch,
    handlePut,
    params,
    isLoading
  };
}

export default GetEvents;
